import { NoDataSVG, PlusSVG } from "../IconSvg";

const NoData = ({
    title,
    btnTxt,
    btnClick
}) => {
    return (
        <div className="empty-data-form d-flex flex-column justify-content-center align-items-center">
            <div className="empty-data-center-icon-holder d-flex flex-row justify-content-center">
                <span>
                    <NoDataSVG />
                </span>
                <div className="empty-data-icons-holder">
                    <div >  </div>
                    <div >  </div>
                    <div>  </div>
                    <div >  </div>
                </div>
            </div>

            <p className="empty-data-form-title">
                {title}
            </p>
            {btnTxt && <button  onClick={btnClick} className=" d-flex flex-row justify-content-between btn btn-primary btn-no-data">
                <span>  <PlusSVG /></span>
                <span>{btnTxt}</span>

            </button>}

        </div>
    )
}

export default NoData;